import React from 'react';

/**
 * Paage view to show when a request was not processed successfully
 */
export const ErrorPage: React.FC = () => {
    return (
        <div className='App'>
            Error!
        </div>
    );
};
